
import { AsgardFeatureNames } from './AsgardFeatures';
import { BehaviorSubject } from 'rxjs';

export enum TabStates {
    CREATE_FILE = 'CREATE_FILE',
    EDIT_FILE = 'EDIT_FILE',
    NO_FILE = 'NO_FILE'
}

export class CurrentTabState {
    private readonly TabStateChange: BehaviorSubject<TabStates> = new BehaviorSubject(TabStates.CREATE_FILE);

    currentTabState: TabStates;
    createFileListDisabledFeatures: AsgardFeatureNames[] = [
        AsgardFeatureNames.ADD_PAGE,
        AsgardFeatureNames.DELETE_PAGE,
        AsgardFeatureNames.MOVE_PAGE_DOWN,
        AsgardFeatureNames.MOVE_PAGE_UP,
        AsgardFeatureNames.TOGGLE_BOTTOM_BAR,
    ];
    listOfActiveFeatures: AsgardFeatureNames[] = [
        AsgardFeatureNames.TOGGLE_BOTTOM_BAR,
    ];
    // currentPageDoc?: number;
    // currentPagesLength?: number;
    // currentZoomValue?: number;
    currVoiceName: string | null = null;
    currLangCode: string | null = null;
    currReadingSpeed: number | null = null;

    constructor(createEditor: boolean = true) {
        this.currentTabState = createEditor ? TabStates.CREATE_FILE : TabStates.NO_FILE;
    }

    /* we need to change state there */
    /* TODO:: add error dialog if user have some unstored data and want to upload file */
    changeTabState() {
        switch (this.currentTabState) {
            case TabStates.NO_FILE:
            case TabStates.CREATE_FILE:
                this.currentTabState = TabStates.EDIT_FILE;
                this.TabStateChange.next(this.currentTabState);
                break;
        }
    }

    getState() {
        return this.TabStateChange.asObservable();
    }

    updateUIDependsOnTabState() {
    }

}

